export default __webpack_public_path__ + "PropaneDefaultPin.png";